export default __webpack_public_path__ + "static/media/newfog4.1bccc041.png";